import { AdminLayout } from '@/components/Layout/Layout';
import api from '@/shared/api/api';
import Button from '@/shared/ui/Buttons/Button';
import { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import TestCaseForm from './form/TestCaseForm';
import { useFetch } from '@/shared/hooks/useFetch';
import { BodyUpdateTestcasesApiTestCasesIdPut } from '@/shared/api/gen/data-contracts';
import { MultiFileInput, AttachmentItem } from '@/shared/ui/Inputs/FileInput/MultiFileInput';

function UpdateTestCase() {
    const { caseID } = useParams();
    const navigate = useNavigate();
    const { data } = useFetch(
        () => api.test_cases.getTestcasesDetailApiTestCasesIdGet(Number(caseID)),
        {} as unknown as object,
        []
    );
    const [attachments, setAttachments] = useState<AttachmentItem[]>([]);

    useEffect(() => {
        const incoming = (data as any)?.attachments;
        if (Array.isArray(incoming)) {
            setAttachments(incoming);
        }
    }, [data]);

    const onSubmit = (formData: BodyUpdateTestcasesApiTestCasesIdPut) => {
        const { attachment, ...restData } = formData;
        // @ts-expect-error ts(2322)
        const attachmentFiles: FileList | string = attachment;
        const attachmentData =
            typeof attachment === 'object'
                ? attachmentFiles?.length > 0
                    ? { attachment: (attachmentFiles as FileList)[0] }
                    : { attachment: null }
                : { attachment: attachment };
        api.test_cases
            .updateTestcasesApiTestCasesIdPut(Number(caseID), { ...restData, ...attachmentData })
            .then(() => navigate(-1));
    };

    const handleAddAttachment = async (file: File): Promise<void> => {
        const result = await api.test_cases.addTestCaseAttachmentApiTestCasesIdAttachmentsPost(
            Number(caseID),
            { file }
        );
        if (result?.data) {
            setAttachments(prev => [...prev, result.data as AttachmentItem]);
        }
    };

    const handleRemoveAttachment = async (id: number): Promise<void> => {
        await api.test_cases.deleteTestCaseAttachmentApiTestCasesIdAttachmentsAttachmentIdDelete(
            Number(caseID),
            id
        );
        setAttachments(prev => prev.filter(a => a.id !== id));
    };

    return (
        <AdminLayout>
            <div className='FormRow'>
                <Button onClick={() => navigate(-1)} style={{ maxWidth: '100px' }}>Назад</Button>
            </div>
            <TestCaseForm defaultData={{ ...data }} onSubmit={onSubmit} />
            <div style={{ marginTop: '16px' }}>
                <h3 className='text-18'>Вложения</h3>
                <MultiFileInput
                    attachments={attachments}
                    onAdd={handleAddAttachment}
                    onRemove={handleRemoveAttachment}
                />
            </div>
        </AdminLayout>
    );
}

export default UpdateTestCase;
